<div ngModelGroup="grupoFuncoes" #grupoFuncoes="ngModelGroup" >        
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados da função</mat-panel-title>
            </mat-expansion-panel-header>

            <!-- DADOS INICIAIS -->
            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                <!-- #FUNCAO -->
                <mat-form-field fxFlex="20%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <mat-label>Função:</mat-label>
                    <mat-select [(ngModel)]="funcoesInstituicao.funcoes.id" name="funcao" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of listaFuncoes" [value]=i.id>
                            {{i.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="listaFuncoes?.length === 0" align="start">Nenhuma função
                        cadastrada</mat-hint>
                </mat-form-field>

                <!-- #FUNCIONARIO -->
                <mat-form-field fxFlex="70%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <mat-label>Funcionario:</mat-label>
                    <mat-select [(ngModel)]=funcoesInstituicao.funcionario.id name="funcionario" required>
                        <mat-option></mat-option>
                        <mat-option *ngFor="let i of funcionarios" [value]=i.id>
                            {{i.pessoasFisica.nome}}
                        </mat-option>
                    </mat-select>
                    <mat-hint *ngIf="funcionarios?.length === 0" align="start">Nenhum funcionário
                        cadastrado</mat-hint>
                </mat-form-field>

            </div>

            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <!-- #DATA INICIO  -->
                <mat-form-field fxFlexOffset="20px" fxFlex="30%">
                    <input [(ngModel)]=funcoesInstituicao.dataInicio matInput name="dataInicio" 
                            [matDatepicker]="dataInicio"
                            (input)="onMascaraDataInput($event)"
                            placeholder="Data de Início:" required>
                    <mat-datepicker-toggle matSuffix [for]="dataInicio">
                    </mat-datepicker-toggle>
                    <mat-datepicker #dataInicio></mat-datepicker>
                </mat-form-field>

                <!-- #DATA  -->
                <mat-form-field fxFlex="30%">
                    <input [(ngModel)]=funcoesInstituicao.dataFim matInput name="dataFim" 
                            [matDatepicker]="dataFim"
                            (input)="onMascaraDataInput($event)"
                            [min]="funcoesInstituicao.dataInicio"
                            placeholder="Data Fim:">
                    <mat-datepicker-toggle matSuffix [for]="dataFim">
                    </mat-datepicker-toggle>
                    <mat-datepicker #dataFim></mat-datepicker>
                </mat-form-field>
            </div>



            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar"  
                        [disabled]="grupoFuncoes.invalid"
                        fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" 
                        [disabled]="grupoFuncoes.invalid"
                        fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>

            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Funções ( {{instituicao?.funcoesInstituicao?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">


                <ng-container matColumnDef="funcionario">
                    <th mat-header-cell *matHeaderCellDef> Funcionário </th>
                    <td mat-cell *matCellDef="let element"> {{element.funcionario?.pessoasFisica?.nome }} </td>
                </ng-container>

                <ng-container matColumnDef="funcao">
                    <th mat-header-cell *matHeaderCellDef> Função </th>
                    <td mat-cell *matCellDef="let element"> {{element.funcoes?.nome}} </td>
                </ng-container>

                <ng-container matColumnDef="dataInicio">
                    <th mat-header-cell *matHeaderCellDef> Data Início </th>
                    <td mat-cell *matCellDef="let element"> {{element.dataInicio | dataSimples}} </td>
                </ng-container>

                <ng-container matColumnDef="dataFim">
                    <th mat-header-cell *matHeaderCellDef> Data Fim </th>
                    <td mat-cell *matCellDef="let element"> {{element.dataFim | dataSimples}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button mat-button (click)="atualizarFuncao(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova função" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</div>